module.exports = __webpack_public_path__ + "static/img/WBGames-Selected.5cbd33b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/WBGames-Selected.png
// module id = 1584
// module chunks = 0